// Runtime config: Cloud Run env vars inyectadas via env-config.js (window.__ENV__)
// Fallback a process.env para desarrollo local (CRA lee .env en build time)
// eslint-disable-next-line no-underscore-dangle
const env = window.__ENV__ || {};

const config = {
  REACT_APP_NODE_API: env.REACT_APP_NODE_API || process.env.REACT_APP_NODE_API,
  REACT_APP_CLIENT_ID: env.REACT_APP_CLIENT_ID || process.env.REACT_APP_CLIENT_ID,
  REACT_APP_WHITELIST: env.REACT_APP_WHITELIST || process.env.REACT_APP_WHITELIST,
  REACT_APP_BLOCKED_EMAILS: env.REACT_APP_BLOCKED_EMAILS || process.env.REACT_APP_BLOCKED_EMAILS,
  REACT_APP_TINY: env.REACT_APP_TINY || process.env.REACT_APP_TINY,
  REACT_APP_API_KEY: env.REACT_APP_API_KEY || process.env.REACT_APP_API_KEY,
  REACT_APP_DEPLOYMENT: env.REACT_APP_DEPLOYMENT || process.env.REACT_APP_DEPLOYMENT,
  REACT_APP_ENABLE_DEBUG: env.REACT_APP_ENABLE_DEBUG || process.env.REACT_APP_ENABLE_DEBUG,
};

export default config;
